import { render, staticRenderFns } from "./mparea.vue?vue&type=template&id=3298b85c&scoped=true&"
import script from "./mparea.vue?vue&type=script&lang=js&"
export * from "./mparea.vue?vue&type=script&lang=js&"
import style0 from "./mparea.vue?vue&type=style&index=0&id=3298b85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3298b85c",
  null
  
)

export default component.exports